export default {
  ApiErrors: {
    generic: 'Ocorreu um erro. Por favor, recarregue a página e contacte-nos se o problema persistir.',
    'Email already exists': 'E-mail indisponível',
    'This field is required.': 'Este campo é obrigatório',
    'First_name must be filled': 'O primeiro nome é obrigatório',
    'Password length must be over 8 characters': 'A palavra-passe deve ter no mínimo 8 caracteres',
    'Unable to login with the provided credentials': 'Não foi possível iniciar sessão com as credenciais fornecidas',
    'godson is already a customer': 'Este e-mail já pertence a um cliente',
    'godson is in referral process': 'Este e-mail já está em processo de apadrinhamento',
    'Enter a valid email address': 'Este endereço de e-mail não é válido',
    'Email already in db': 'E-mail indisponível',
    'Not an email': 'E-mail inválido',
    'Reward is soldout': 'Esta recompensa está esgotada',
    'Reward can only be claimed once': 'Já reclamou esta recompensa',
    'Reward is no longer valid': 'Esta recompensa já não é válida',
    'Not enough points': 'Não tem pontos suficientes',
    'Account already in use': 'Esta conta já está a ser usada por outro utilizador',
    'This instagram account does not exist on Instagram': 'Esta conta de Instagram não existe',
    'social error': "Por favor, introduza a sua conta {'@'}a_sua_conta",
    'required field': 'Por favor, preencha este campo',
    'value error': 'O valor introduzido não é válido',
    'You already applied a discount code': 'Já aplicou um código de desconto'
  },
  Error: {
    generic: 'Ocorreu um erro, por favor recarregue a página.',
    link: 'Recarregar a página',
    title: 'Loyoly - Ups! Erro',
    blacklistMessage1: 'Não é elegível para o programa de fidelização.',
    blacklistMessage2: 'Contacte a equipa de suporte se acha que isto é um erro.'
  },
  FormEmail: {
    example: "johndoe{'@'}gmail.com",
    errors: {
      email: 'Por favor, introduza um endereço de e-mail válido',
      emailEmpty: 'Por favor, introduza o seu endereço de e-mail'
    }
  },
  InApp: {
    message: 'Para uma melhor experiência, aceda através do seu navegador padrão'
  },
  Phone: {
    countrySelector: {
      placeholder: 'Código do país',
      error: 'Escolha um país',
      searchPlaceholder: 'Selecione um país'
    },
    phoneInput: { placeholder: 'Número de telemóvel', example: 'Exemplo:' },
    error: { invalid: 'Introduza um número de telemóvel válido' }
  },
  Instagram: {
    ModalNotLinked: {
      title: 'Iniciar sessão com a minha conta Instagram',
      subtitle: 'Como funciona',
      description:
        'Por favor, introduza a sua conta de Instagram e certifique-se de que está pública antes de realizar as missões.',
      form: { username: 'Conta de Instagram', usernameExample: "{'@'}johndoe" },
      errors: {
        usernameEmpty: 'Por favor, introduza o nome da sua conta',
        usernameNotFound: 'Por favor, introduza um nome de conta válido'
      },
      button: 'Validar'
    },
    ModalSearching: { title: 'Estamos a procurar a sua conta' },
    ModalLinked: {
      title: 'Iniciar sessão com a minha conta Instagram',
      private: {
        subtitle: 'Não foi possível ligar a sua conta',
        description: {
          title: 'A sua conta de Instagram é privada',
          text: 'Ups, parece que a sua conta de Instagram está privada. Torne-a pública para ter acesso a todas as missões.'
        }
      },
      public: {
        subtitle: 'Ligação à sua conta bem-sucedida',
        description: { title: 'Parabéns', text: 'Pode agora realizar as missões.' }
      },
      buttons: {
        edit: 'Editar a minha conta',
        retry: 'Tentar novamente',
        goback: 'Voltar à página',
        gotoChallenge: 'Ir para a missão'
      }
    },
    ModalNotFound: {
      title: 'Iniciar sessão com a minha conta Instagram',
      subtitle: 'Não foi possível ligar a sua conta',
      description: { title: 'Conta não encontrada', text: 'Sugerimos que altere de conta ou contacte o suporte.' },
      buttons: { change: 'Mudar de conta', retry: 'Tentar novamente' }
    }
  },
  Modal: {
    Notifications: {
      title: 'Notificações por e-mail',
      information: {
        title: 'Informações',
        text: 'Se não quiser receber lembretes de missões, novidades ou lembretes de recompensas, pode cancelar a subscrição desativando as caixas abaixo:'
      },
      communication: {
        optinTransactional: 'Promocionais: informações sobre o programa, níveis VIP, recompensas.',
        optinMarketing: 'Informativas: informações sobre compras e apadrinhamento.'
      }
    },
    SocialAccount: {
      Info: {
        public: 'Conta pública',
        private: 'Conta privada',
        followers: '<span class="weglot-ignore">{n}</span> seguidor | <span class="weglot-ignore">{n}</span> seguidores'
      }
    }
  },
  Points: '<span class="weglot-ignore">{n}</span> ponto | <span class="weglot-ignore">{n}</span> pontos',
  PointsDecimal: '<span class="weglot-ignore">{value}</span> ponto | <span class="weglot-ignore">{value}</span> pontos',
  SectionHeader: { poweredBy: 'Com tecnologia de' },
  SectionChallenges: {
    empty: 'Não há missões disponíveis no seu programa de fidelização',
    showAll: 'Ver tudo',
    ModalMissionDetail: {
      description: 'Descrição',
      pointsToEarn: 'Pontos a ganhar',
      howto: 'Como funciona?',
      uploadMedia: 'Importar o seu conteúdo',
      reviewApplication: 'Deixar uma avaliação',
      linkApplication: 'Transferir a aplicação',
      newsletterPartners:
        'Ao clicar em “Validar a missão”, aceita receber comunicações comerciais da empresa por via eletrónica.',
      phonePartners: 'Autorizo a utilização do meu número de telefone para receber ofertas por SMS.',
      clue: 'Dica',
      linkPage: 'Ver página',
      instaMention: 'Identifique',
      tiktokMention: 'Identifique',
      instaHashtags: 'Hashtag(s) a utilizar',
      tiktokHashtags: 'Hashtag(s) a utilizar',
      linkToShare: 'Link a colocar na sua story',
      linkShare: 'Link a partilhar',
      vouchertoShare: 'Código promocional a partilhar',
      goToAccount: 'Ir para a conta',
      goToInsta: 'Ir para a conta',
      goToInstaPost: 'Ir para a publicação no Instagram',
      goToInstaReel: 'Ir para o reel no Instagram',
      goToInstaIGTV: 'Ir para o IGTV no Instagram',
      goToTweeterTweet: 'Ir para o Tweet',
      goToReview: 'Deixar uma avaliação',
      goToShop: 'Ir para a loja',
      goToLink: 'Ir para a página',
      goToTypeform: 'Preencher o formulário',
      goToWhatsapp: 'Entrar no grupo',
      submit: 'Validar a missão',
      missionPendingTitle: 'Missão em validação',
      missionPendingExplain: 'Os seus pontos serão creditados em breve.',
      actionSurveyTextError: 'Por favor, selecione uma resposta',
      actionEmailError: 'O seu e-mail não é válido',
      actionInputError: 'Este campo não é válido',
      actionInputImageError: 'Por favor, importe o seu conteúdo',
      handlingMedia: 'A processar o conteúdo',
      errorMediaHandle: 'Ocorreu um erro ao processar o seu conteúdo',
      imageInvalid: 'Ocorreu um erro ao processar o seu conteúdo',
      videoSize: 'O seu vídeo deve ter menos de 100MB.',
      errorInstaReel: 'O URL do seu reel é inválido',
      'This url is not a valid google url': 'O URL da sua avaliação Google é inválido',
      'This url is not a valid reel url': 'O URL do seu reel é inválido',
      refusalReasonCondition: 'Condições não respeitadas',
      refusalReasonQuality: 'Qualidade insuficiente',
      refusalReasonContent: 'Conteúdo inapropriado',
      refusalReasonSound: 'Som inaudível',
      missionInvalidTitle: 'Missão invalidada',
      missionInvalidDescription: 'Pode repetir a missão respeitando cuidadosamente as regras indicadas',
      missionInvalidReasons: 'Motivo da recusa:',
      condition: 'Condições',
      conditionExplanation: 'Ter mais de',
      ineligible: 'Não elegível',
      ineligibleExplanation:
        'Parece que não tem o número de seguidores necessário. Se tiver mais, atualize os dados da sua conta.',
      lastUpdate: 'Última atualização a',
      updateAccount: 'Atualizar a minha conta',
      reviewLastPurchase: 'Avaliar o produto da sua última compra',
      whenReviewValidated: 'Assim que a avaliação for validada, a missão será automaticamente validada',
      pointsToEarnPhoto: 'Pontos extra com foto',
      pointsToEarnVideo: 'Pontos extra com vídeo',
      howtoBirthdate: 'Indique a sua data de nascimento',
      errorInvalidDate: 'Por favor, introduza uma data válida',
      inputMedia: 'Importar o seu conteúdo',
      inputMediaLoaded: 'O seu conteúdo foi importado com sucesso',
      placeholderAnswer: 'Escreva aqui a sua resposta',
      misteryAnswer: 'Qual é a palavra mistério?',
      newsletterEmail: 'Confirme o seu endereço de e-mail',
      birthDate: 'Data de nascimento',
      example: 'Exemplo',
      goToChallenge: 'Ir para a missão'
    },
    ModalMissionImageRights: {
      imageRights:
        'Ao assinalar esta caixa, confirmo ser o autor do conteúdo, aceito expressamente ceder os direitos de propriedade intelectual correspondentes, e autorizo a utilização da minha imagem pela marca para fins comerciais, conforme descrito em ',
      imageRightsLink: 'este acordo.',
      title:
        'Acordo de cessão de direitos de propriedade intelectual sobre o conteúdo e autorização de utilização da minha imagem.',
      content: 'Aceito expressamente que a publicação do conteúdo realizado no âmbito da minha missão (o “Conteúdo”):',
      bullet1:
        'implica a cessão, a favor da marca, da totalidade dos direitos de autor correspondentes, para todo o mundo, durante toda a duração legal de proteção desses direitos. Reconheço que esta cessão é feita em troca dos pontos ganhos na missão, que constituem a devida compensação. Esta cessão inclui o direito de reprodução e representação do Conteúdo, parcial ou total, em todos os suportes e meios, existentes ou futuros, bem como o direito de traduzir, modificar, adaptar e/ou corrigir o Conteúdo. Declaro que este Conteúdo não infringe direitos de terceiros nem constitui infração de direitos de autor e isento a marca de qualquer responsabilidade.',
      bullet2:
        'implica a autorização, a título gratuito, à marca para fixar, reproduzir, divulgar e comunicar publicamente os meus atributos de personalidade associados ao Conteúdo, em todos os meios e suportes, conhecidos ou desconhecidos, previsíveis ou não, para fins de exploração, comunicação, promoção e publicidade dos produtos da marca, por um período de 10 anos, renovável mediante acordo mútuo.',
      end1: 'Este acordo está sujeito à legislação francesa e será interpretado de acordo com a mesma.',
      end2: 'Qualquer litígio relacionado com a validade, interpretação ou execução do presente acordo será da competência exclusiva dos Tribunais de Paris, salvo disposição em contrário.'
    },
    ModalMissionLoyaltyDetail: {
      pointsToEarn:
        '<span class="weglot-ignore">{points}</span> ponto a ganhar por cada <span class="weglot-ignore">{amountToPoints}</span> gastos | <span class="weglot-ignore">{points}</span> pontos por cada <span class="weglot-ignore">{amountToPoints}</span> gastos',
      orderNumber: 'Encomenda N.º',
      orderDate: 'Data',
      orderAmount: 'Valor',
      orderRewardable: 'Elegível para recompensa',
      orderPoints: 'Pontos ganhos',
      orderPaid: 'Validado',
      orderStatus: 'Estado',
      orderCancel: 'Reembolsado',
      orderRefund: 'Parcialmente reembolsado',
      orderWaiting: 'Pendente'
    },
    CompanyConditions: {
      seeTermsAndConditions: 'Ver as condições',
      seePrivacy: 'Ver a privacidade'
    }
  },
  SectionProfile: {
    socialNetworks: {
      instagram: 'Ligação ao Instagram',
      tiktok: 'Ligação ao TikTok'
    },
    notificationsByEmails: 'Notificações por e-mail',
    cgu: 'Termos e condições'
  },
  SectionAccountRewards: {
    empty: 'Já não há recompensas para trocar e não tem recompensas pendentes por utilizar',
    copied: 'Copiado!'
  },
  SectionRewards: {
    empty: 'Não há recompensas disponíveis no seu programa de fidelização',
    showAll: 'Ver tudo',
    Card: {
      channel_store: 'Na loja física',
      channel_online: 'Online',
      channel_both: 'Online e na loja física'
    }
  },
  SectionRewardsModalMyRewards: {
    title: 'As minhas recompensas',
    empty: 'Ainda não tem recompensas.',
    emptyTip: 'Pode completar missões e trocar os seus pontos por recompensas',
    use: 'Utilizar',
    expired: 'Expirada'
  },
  SectionRewardsDetailInfos: {
    expireDate: 'Data de expiração',
    expirationDelayExplain:
      'A recompensa será utilizável durante <span class="weglot-ignore">{expiration_delay}</span> dias após a troca.',
    minimumBuy: 'Compra mínima',
    maxAmount: 'Válido até um máximo de',
    description: 'Descrição',
    saleChannel: 'Canal de venda',
    channelStore: 'Na loja física',
    channelOnline: 'Online',
    channelBoth: 'Online e na loja física'
  },
  SectionRewardsDetailModal: {
    exchange: 'Trocar',
    errorMessage1: 'Parece que ocorreu um problema.',
    errorMessage2: 'A sua recompensa não foi trocada e os seus pontos não foram descontados.',
    errorMessage3: 'Por favor, recarregue a página.',
    errorButton: 'Recarregar a página'
  },
  SectionRewardsClaimModal: {
    howItWorks: 'Como funciona?',
    howItWorkCode: 'Utilize o seu código no nosso site durante a encomenda',
    howItWorkCodeProduct: 'Adicione o produto ao carrinho e utilize o código no checkout',
    howItWorkCodeRecharge: 'Adicione o código diretamente no seu portal de cliente',
    howItWorkExt: 'Será contactado para receber a sua recompensa',
    applyToBasket: 'Aplicar ao carrinho',
    apply: 'Aplicar',
    appied: 'Aplicado',
    link: 'Link para o produto',
    copied: 'Copiado!',
    customerPortal: 'Portal de cliente',
    nonApplicable: 'Não elegível'
  },
  SectionRewardsDetailsRechargeSubscriptions: {
    apply: 'Aplicar',
    nonApplicable: 'Não elegível',
    itemTitle: '{title} / {price}'
  },
  SectionReferral: {
    friendEmail: 'E-mail do seu amigo',
    seeReferral: 'Ver os meus apadrinhamentos',
    errors: { emailSelf: 'O e-mail introduzido é igual ao seu' },
    Tabs: {
      link: 'Link',
      email: 'E-mail',
      sms: 'SMS',
      copy: 'Copiar link',
      smsSend: 'Enviar mensagem',
      reward1: '{amount} pontos',
      reward2: '{amount}% de desconto',
      reward3: 'vale de {amount}',
      smsTemplate:
        'Olá! Descobri {brand_name} e acho que vais gostar.\n\nAo usares o meu link de apadrinhamento {referral_link}, recebes {reward_friend}.\n\nAproveita, é uma oferta imperdível!\nAté já!'
    },
    Modal: {
      emptyState: 'Ainda não realizou nenhum apadrinhamento',
      title: 'Os meus apadrinhamentos',
      status: 'Estado',
      email: 'E-mail',
      date: 'Data de expiração',
      statusPending: 'Pendente',
      statusUsed: 'Já utilizado',
      statusAvailable: 'Disponível',
      statusExpired: 'Expirado',
      statusInvalidate: 'Invalidado',
      promocodeComing: 'Em breve',
      promocodeUnavailable: '-',
      promocodeInvalidate: 'Invalidado',
      points_given: 'Os seus pontos foram creditados',
      referral_type_3: 'Vale de desconto',
      referral_type_2: 'Código promocional',
      referral_type_1: 'Pontos'
    },
    NotAuthenticatedForm: {
      emailPlaceholder: 'E-mail',
      emailError: 'O formato do e-mail é inválido',
      emailEmpty: 'Por favor, preencha este campo',
      emailUnknown: 'Crie uma conta para poder apadrinhar'
    }
  },
  SectionVipTiersProgress: { you: 'Você', points: 'pontos' },
  SectionVipTiersCard: {
    rewardPoints: '{points} pontos oferecidos',
    rewardMultiplier: 'Multiplicador de pontos: x{multiplier}',

    tiersPoints: '{amount} pontos'
  },
  SectionGifting: {
    empty: 'Não há testes de produto disponíveis neste momento',
    showAll: 'Ver tudo',
    ModalApply: {
      endDate: 'Data limite de candidatura',
      description: 'Descrição',
      completeForm: 'Preencha o formulário para se candidatar',
      button: 'Candidatar-se',
      success: {
        title: 'Inscrição no teste de produto',
        description:
          'Obrigado por preencher as suas informações. A sua candidatura está a ser analisada. Será notificado por e-mail.'
      },
      Form: { Errors: { required: 'Por favor, preencha este campo', date: 'Por favor, introduza uma data válida' } }
    },
    ModalParticipate: {
      challenges: 'Missões',
      howItWorks: 'Como funciona?',
      useCode: 'Utilize o seu código no nosso site ao realizar a compra.',
      youWillBeContacted: 'Será contactado para receber o seu produto.',
      buttonLink: 'Link para o produto',
      buttonCopied: 'Copiado!'
    }
  },
  SectionGiftingCardList: {
    status: {
      participate: 'Participar',
      underValidation: 'Em validação',
      apply: 'Candidatar-se',
      ended: 'Terminado',
      rejected: 'Candidatura não aceite'
    }
  },
  SectionSteps: {
    Authenticated: { month: '{n} mês | {n} meses' },
    ModalActivities: {
      title: 'As minhas atividades recentes',
      empty: 'Ainda não tem atividades recentes.',
      table: { header: { title: 'Título', points: 'Pontos', date: 'Data' } },
      events: {
        challenge: 'Missão validada',
        order: 'Compra realizada',
        reward: 'Recompensa obtida',
        refferal: 'Apadrinhamento validado',
        userAction: 'Pontos ajustados',
        level: 'Nível alcançado',
        levelLabel: 'Nível {level}',
        reset: 'Expiração dos pontos',
        automation: 'Pontos ganhos'
      }
    }
  },
  Tiktok: {
    ModalNotLinked: {
      title: 'Iniciar sessão com a minha conta TikTok',
      subtitle: 'Como funciona',
      description:
        'Por favor, introduza a sua conta TikTok e certifique-se de que está pública. Depois poderá realizar missões TikTok.',
      button: 'Ligar a minha conta'
    },
    ModalLinked: {
      title: 'Iniciar sessão com a minha conta TikTok',
      subtitle: 'Ligação com a sua conta concluída com sucesso',
      congratulations: 'Parabéns',
      description: 'Pode agora realizar as missões.',
      buttons: { edit: 'Editar a minha conta', goback: 'Voltar à página' }
    }
  },
  SectionReferralFriend: {
    placeholder: 'Endereço de e-mail',
    emailError: 'Por favor, introduza um endereço de e-mail válido',
    emailEmpty: 'Por favor, introduza o seu endereço de e-mail',
    disclaimer: 'Esta oferta é válida apenas para novos clientes',
    disclaimerVerification: 'Não será contactado para fins comerciais.',
    referral_type_3: 'Vale de desconto',
    referral_type_2: 'Código promocional',
    referral_type_1: 'Pontos',
    copied: 'Copiado!',
    label_optin_reminder: 'Quero receber um lembrete se não utilizar o meu desconto.',
    btn_optin_reminder: 'Receber um lembrete do meu código'
  },
  Unsubscribe: {
    title: 'Tem a certeza de que deseja cancelar a subscrição dos e-mails do nosso programa de fidelização?',
    description: 'Se o fizer, deixará de receber informações sobre as suas recompensas, missões e pontos.',
    email: 'E-mail',
    button: 'Atualizar as minhas preferências',
    question: 'Que tipo de e-mails deseja receber:',
    optinTransactional: 'Promocionais: informações sobre o programa, níveis VIP, recompensas.',
    optinMarketing: 'Informativos: informações sobre compras e apadrinhamento.',
    successTitle: 'As suas preferências foram atualizadas',
    successDescription: 'Utilize o botão abaixo para rever ou alterar as suas preferências',
    successButton: 'Atualizar as minhas preferências',
    errorTitle: 'Ocorreu um erro com o link de redirecionamento',
    errorButton: 'Voltar ao site'
  },
  SectionAccount: { copied: 'Copiado!' },
  SectionPointCard: { you: 'Você', copied: 'Copiado!' }
}
